var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.334 26.667c-5.34 0-9.667-4.775-9.667-10.666S6.995 5.334 12.334 5.334c4.241 0 7.845 3.015 9.147 7.208A7.083 7.083 0 1122 26.663v.004h-9.667z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }